<main>
  <div class="container d-flex justify-content-center align-items-center">
    <div class="jumbotron text-center">
      <h2>Регистрация</h2>
      <p>Свяжитесь с администратором</p>
    </div>
  </div>
</main>